import { useFloating, autoUpdate, useFloatingNodeId } from '@floating-ui/react';
export const useFloatingDropdown = (isOpen, handleOpenChange, additionalMiddlewares) => {
  const nodeId = useFloatingNodeId();
  const floating = useFloating({
    nodeId,
    open: isOpen,
    onOpenChange: handleOpenChange,
    placement: 'bottom-start',
    middleware: additionalMiddlewares,
    whileElementsMounted: autoUpdate
  });
  return {
    nodeId,
    floating
  };
};